import { FC, ReactNode } from "react";
import { ProColumns } from "@ant-design/pro-table";
import { connect } from "react-redux";
import { RootState } from "reducers";
import OrderAfterSalesDetails from "./order-after-sales-details";
import { deleteEntity, getEntities, getEntity } from "./order-after-sales.reducer";
import { RouteComponentProps } from "@reach/router";
import ListViewPage from "layouts/page-wraper/list-view-page";
import OrderAfterSalesEdit from "./order-after-sales-edit";
import { internationalDetails, internationalList } from "components/IntelFormText";
import { OrderAfterSales } from "model/procure/order-after-sales.model";


export interface OrderAfterSalesListProps
  extends StateProps, DispatchProps, RouteComponentProps {
  children?: ReactNode;
}
const columns: ProColumns<OrderAfterSales>[] = [{
  title: 'id',
  dataIndex: 'id',
}, {
  title: '编码',
  dataIndex: 'code',
}, {
  title: '售后退款原因',
  dataIndex: 'desc',
  hideInDescriptions: true,
  render: (dom, record) => <>{internationalList(record.desc || '')}</>
}, {
  title: '售后退款原因',
  dataIndex: 'desc',
  hideInTable: true,
  render: (dom, record) => <span className="product-name" dangerouslySetInnerHTML={{ __html: internationalDetails(record.desc || '') }}></span>
}];

const OrderAfterSalesList: FC<OrderAfterSalesListProps> = (props) => {

  return (
    <ListViewPage<OrderAfterSales>
      columns={columns}
      quickFilterPanel={false}
      detailPage={<OrderAfterSalesDetails navigate={props.navigate} columns={columns} />}
      detailsIndex={1}
      editPage={(params: any) => <OrderAfterSalesEdit id={params.id} text={params.text} />}
      {...props}
    >
      {props.children}
    </ListViewPage>
  );
};

const mapStateToProps = ({ orderAfterSales }: RootState) => ({
  entity: orderAfterSales.entity,
  entities: orderAfterSales.entities,
  loading: orderAfterSales.loading,
  updateSuccess: orderAfterSales.updateSuccess,
  createSuccess: orderAfterSales.createSuccess,
  total: orderAfterSales.total
});

const mapDispatchToProps = {
  getEntity,
  getEntities,
  deleteEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(OrderAfterSalesList);